import React, { Fragment, /* useContext, */ useState } from 'react';
/*
import { useNavigate } from "react-router-dom";
import { UserContext } from "../UserContext";
*/
import AppAdminListView from "./AppAdminListView";
import AppAdminDetailsView from "./AppAdminDetailsView";
import AppAdminNewView from "./AppAdminNewView";


const AppAdmin = () => {

/*
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
*/

  const [uiMode,     setUIMode]     = useState('LIST');
  const [objDetails, setObjDetails] = useState({});
  const [pageState,  setPageState]  = useState({
                                        searchTerms: null,
                                        sortCol:     null,
                                        sortDir:     null,
                                        perPage:     25,
                                        currPage:    1});

  // Initialize state
/*
  useEffect(() => {

    // Route to home page if not authorized
    if (!hasAnyPerm(user, ["BuildingAdminGeneralWriteAccess"], true)) {
      navigate("/AdminHome/Dashboard", {
        state: {
          //...values
          target: 'Dashboard'
        }
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
*/


  return (
    <Fragment>

      {(uiMode === 'LIST')    ? <AppAdminListView    pageState={pageState} onUIMode={setUIMode}
                                                     onSetPageState={setPageState} onSetObjDetails={setObjDetails} /> : null}
      {(uiMode === 'DETAILS') ? <AppAdminDetailsView onUIMode={setUIMode} objDetails={objDetails} />                  : null}
      {(uiMode === 'NEW')     ? <AppAdminNewView     onUIMode={setUIMode} />                                          : null}

    </Fragment>
  )
}

export default AppAdmin;
